var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_1664","data-name":"Path 1664","d":"M-1424.2,779l6.609,6.609,6.609-6.609","transform":"translate(1424.911 -778.293)","fill":"none","stroke":"#fff","strokeWidth":"2"}));
}

Arrow.defaultProps = {"width":"14.632","height":"8.73","viewBox":"0 0 14.632 8.73"};

module.exports = Arrow;

Arrow.default = Arrow;
